__turbopack_context__.v({
  "card": "page-module-scss-module__I9wYMa__card",
  "colorBar": "page-module-scss-module__I9wYMa__colorBar",
  "colorBars": "page-module-scss-module__I9wYMa__colorBars",
  "content": "page-module-scss-module__I9wYMa__content",
  "contentRow": "page-module-scss-module__I9wYMa__contentRow",
  "defaultImg": "page-module-scss-module__I9wYMa__defaultImg",
  "discount": "page-module-scss-module__I9wYMa__discount",
  "filterRow": "page-module-scss-module__I9wYMa__filterRow",
  "grid": "page-module-scss-module__I9wYMa__grid",
  "image": "page-module-scss-module__I9wYMa__image",
  "imageLink": "page-module-scss-module__I9wYMa__imageLink",
  "imageWrap": "page-module-scss-module__I9wYMa__imageWrap",
  "info": "page-module-scss-module__I9wYMa__info",
  "metaRow": "page-module-scss-module__I9wYMa__metaRow",
  "name": "page-module-scss-module__I9wYMa__name",
  "originalPrice": "page-module-scss-module__I9wYMa__originalPrice",
  "page": "page-module-scss-module__I9wYMa__page",
  "pageTitle": "page-module-scss-module__I9wYMa__pageTitle",
  "paging": "page-module-scss-module__I9wYMa__paging",
  "pagingBtn": "page-module-scss-module__I9wYMa__pagingBtn",
  "price": "page-module-scss-module__I9wYMa__price",
  "priceRow": "page-module-scss-module__I9wYMa__priceRow",
  "seasonAutumn": "page-module-scss-module__I9wYMa__seasonAutumn",
  "seasonSpring": "page-module-scss-module__I9wYMa__seasonSpring",
  "seasonSummer": "page-module-scss-module__I9wYMa__seasonSummer",
  "seasonTag": "page-module-scss-module__I9wYMa__seasonTag",
  "seasonTags": "page-module-scss-module__I9wYMa__seasonTags",
  "seasonWinter": "page-module-scss-module__I9wYMa__seasonWinter",
  "sortArrow": "page-module-scss-module__I9wYMa__sortArrow",
  "sortBtn": "page-module-scss-module__I9wYMa__sortBtn",
  "sortSelect": "page-module-scss-module__I9wYMa__sortSelect",
  "sortWrap": "page-module-scss-module__I9wYMa__sortWrap",
  "subTitle": "page-module-scss-module__I9wYMa__subTitle",
  "title": "page-module-scss-module__I9wYMa__title",
});
